import React, { useEffect, useState } from 'react';
import logo from '../assets/img/logo.png';
import formatString from "format-string-by-pattern";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { resetPass, setResetPass } from '../services/user.service';

export default function RequestResetPass(props) {
    let navigate = useNavigate();

    useEffect(() => {
        document.addEventListener('keypress', async function (e) {
            if (e.which === 13) {
                await handleOnclick();
            }
        }, false);

        async function fetchData() {
            let currenttoken = props?.location?.search.replace('?hash=', '');
            let result = await setResetPass(currenttoken);
            if (result && result.status === 200) {
                toast.success('Sua senha foi atualizada confira seu email.');
                navigate('/login');
            }
            else {
                toast.warning('Não foi possível alterar sua senha!');
            }
        }

        fetchData();

    }, [navigate]);


    const [user, setUser] = useState(undefined);
    const [isLoader, setIsloader] = useState(false);

    const userHandleChange = (value) => {
        let formatCpf = formatString('000.000.000-00', value);
        setUser(formatCpf);
    }

    const handleOnclick = async () => {
        setIsloader(true);
        resetPass(user);
        setIsloader(false);

        navigate('/login')
    }

    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-light fixed-top py-3" id="mainNav">
                <div className="container">
                    <a className="navbar-brand js-scroll-trigger" href="/"><img src={logo} width="100" height="100" alt="Hondix" /></a>
                    <button className="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon" />
                    </button>
                    <div className="collapse navbar-collapse" id="navbarResponsive">

                    </div>
                </div>
            </nav>
            <div className="simple-login-container">
                <h2>Informe seu usuário</h2>
                <div className="row">
                    <div className="col-md-12 form-group">
                        <input type="text" className="form-control" value={user} placeholder="Usuário" required onChange={(e) => userHandleChange(e.target.value)} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 form-group">
                        <button type="submit" className="btn btn-block btn-login" onClick={() => handleOnclick()}  ><span className={isLoader ? ' spinner-border spinner-border-sm' : ''}></span> Entrar</button>
                    </div>
                </div>
            </div>
        </>
    )
}
